<template>
  <HomeLayout>
    <div class="container" v-if="loading">
      <ProgressPage/>
    </div>
    <div v-if="!loading">
      <div class="show-soil-consulting">
        <div>
          <!-- Service --->
          <div class="header border-bottom">
            <div class="d-flex justify-content-between align-items-center">
              <div v-if="service !== null" class="d-flex align-items-center">
                <span class="farm-title"> {{ serviceName !== null ? serviceName : '' }}</span>
                <span class="farm-area">
                  {{serviceArea !== null ? "(" + serviceArea.area + " " + serviceArea.unit + ")" : "" }}
                </span>
              </div>
              <div class="d-flex align-items-center pointer" @click="backToPrevPage">
                <span class="back-home-link">بازگشت</span>
                <span>
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                  >
                    <g
                        id="Iconly_Light_Arrow_-_Down_2"
                        data-name="Iconly/Light/Arrow - Down 2"
                        transform="translate(10) rotate(90)"
                    >
                      <g
                          id="Arrow_-_Down_2"
                          data-name="Arrow - Down 2"
                          transform="translate(2.083 3.542)"
                      >
                        <path
                            id="Stroke_1"
                            data-name="Stroke 1"
                            d="M5.833,0,2.917,2.917,0,0"
                            fill="none"
                            stroke="#7fd2bc"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1.2"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <!-- Plant --->
          <div class="row">
            <div class="col">
              <h3 class="d-inline">
                {{plant !== null ? `محصول ${plant.crop !== null ? plant.crop.name : plant.flower_type.name}` : ''}}
              </h3>
              <span class="text-muted col-5" v-if="plant !== null && plant.area !== null">
                ({{plant.area.area + " " + plant.area.unit}})
              </span>
            </div>
            <div class="col">
              <span class="float-start mt-1 text-small text-success">وضعیت: {{status !== null ? status.title_fa : ''}}</span>
            </div>
          </div>

          <!-- Body --->
          <div class="row" v-if="status !== null && status.code !== 0">
            <div class="chat-container" ref="chatContainer">
              <div v-for="(message, index) in messages" :key="index"
                   :class="['message', message.isFarmer ? 'user-message' : 'expert-message']">
                <p><strong>{{ message.from }}:</strong></p>
                <p>{{ message.text }}</p>
                <small>{{ message.timestamp }}</small>
              </div>
            </div>
            <div v-if="status !== null && status.code !== 11" class="message-input">
              <textarea
                  v-model="newMessage"
                  placeholder="پیام خود را بنویسید..."
                  rows="3">
              </textarea>
              <button @click="sendMessage">ارسال</button>
            </div>
            <div v-if="status !== null && status.code === 11" class="HerbalAdviceSubText">
              مشاوره شما به پایان رسیده است. جهت طرح مشاوره های بیشتر از منوی اشتراک، مشاوره جدید آغاز کنید.
            </div>
          </div>

          <div class="row justify-content-center" v-else>
                <div class="row mb-12">
                <div class="col text-center">
                  در انتظار بررسی
                </div>
              </div>
              </div>
        </div>
      </div>
    </div>
  </HomeLayout>
</template>

<script>
import HomeLayout from "../layout/HomeLayout";
import {globalMixin} from "../mixins/globalMixin";
import ProgressPage from "../components/UI/ProgressPage";
import Api from "../common/api";

export default {
  name: "ShowPlantConsulting",
  components: {ProgressPage, HomeLayout},
  mixins: [globalMixin],
  inject: ["$axios"],
  data() {
    return {
      serviceName: null,
      serviceArea: null,
      plant: null,
      consult: null,
      status: null,
      createAt: null,
      user: null,
      userName: null,
      userId: null,
      messages: [],
      newMessage: "",
    };
  },
  props: ["id"],
  methods: {
    getConsultResult() {
      let self = this;
      Api.singleConsultApi({self: this, id: this.id})
          .then((res) => {
            if (res.status === 200) {
              let data = res.data;
              self.loading = false;
              self.serviceName = data.service && data.service.parent ? data.service.parent.name : data.service.name;
              self.serviceArea = data.service && data.service.parent ? data.service.parent.area : data.service.area;
              self.plant = data.service && data.service.parent ? data.service : null;
              self.consult = data || null;
              self.status = data ? data.status : null;
              self.createAt = data && data.create_at;
            }
          })
          .catch((error) => {
            self.loading = false;
            this.toastReturnTxt(error.response);
          });
    },
    fetchMessages() {
      const consultId = this.id;
      this.$axios.get(`consulting/${consultId}/messages`)
          .then(response => {
            this.messages = response.data.map(message => ({
              id: message.id,
              text: message.message,
              isFarmer: message.is_farmer,
              from: message.from,
              timestamp: message.created_at
            }));
            this.scrollToBottom();
          })
          .catch(error => {
            console.error("Error fetching messages:", error);
          });
    },
    sendMessage() {
      if (!this.newMessage.trim()) return;  // Avoid empty messages

      const consultId = this.id;
      const payload = { message: this.newMessage };

      this.$axios.post(`consulting/${consultId}/messages`, payload)
          .then(response => {
            this.messages.push({
              id: response.data.id,
              text: this.newMessage,
              from: response.data.from,
              isFarmer: response.data.isFarmer,
              timestamp: response.data.created_at
            });
            this.newMessage = "";
            this.scrollToBottom();
          })
          .catch(error => {
            console.error("Error sending message:", error);
          });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatContainer = this.$refs.chatContainer;
        if (chatContainer) chatContainer.scrollTop = chatContainer.scrollHeight;
      });
    }
  },
  created() {
    this.loading = true;
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("user"));
    this.userId = user.id;
    this.userName = user.name;
    this.getConsultResult();
    this.fetchMessages();
  }
};
</script>



<style lang="scss">
@import "src/styles/modules/ShowPlantConsulting/ShowPlantConsulting";
</style>


